import { capitalize, last, get } from 'lodash-es';
import { getBaseBreadcrumb, getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';
import { VEHICLE_MAKES_SITEMAP_ROUTE } from 'client/site-modules/sitemap/constants/routes';

// we remove the first element because it is always empty and the last because it is always sitemap itself
const getLocationsFromPathname = pathname => pathname.split('/').slice(1, -1);

const getLocationName = pathname =>
  pathname
    .split('-')
    .map(word => capitalize(word))
    .join(' ');

const getCategoriesFromPathname = pathname => {
  const locations = getLocationsFromPathname(pathname);
  return locations.map(getLocationName);
};

const generateTitleFromPathname = pathname => {
  const categories = getCategoriesFromPathname(pathname);
  const categoriesTitle = categories.join(' ').trim();

  return categoriesTitle;
};

export const getSitemapTitle = ({ pathname, makeName, modelName, withSitemapLabel = true }) => {
  let title = '';

  if (modelName) {
    title = `${makeName} ${modelName}`;
  } else if (makeName) {
    title = `${makeName}`;
  } else {
    switch (pathname) {
      case VEHICLE_MAKES_SITEMAP_ROUTE:
        title = 'Makes';
        break;
      case '/cpo-make.html':
        title = 'CPO Make';
        break;
      case '/cpo-model.html':
        title = 'CPO Model';
        break;
      case '/uci-black.html':
        title = 'Used Car Inventory Black';
        break;
      case '/uci-white.html':
        title = 'Used Car Inventory White';
        break;
      case '/make-lease.html':
        title = 'Make Lease';
        break;
      case '/lease-model.html':
        title = 'Lease Model';
        break;
      case '/type-lease.html':
        title = 'Type Lease';
        break;
      case '/uci-cars-location.html':
        title = 'Used Car Inventory Cars Location';
        break;
      case '/uci-make.html':
        title = 'Used Car Inventory Make';
        break;
      case '/uci-make-location.html':
        title = 'Used Car Inventory Make Location';
        break;
      case '/uci-make-type.html':
        title = 'Used Car Inventory Make Type';
        break;
      case '/uci-model.html':
        title = 'Used Car Inventory Model';
        break;
      case '/uci-model-location.html':
        title = 'Used Car Inventory Model Location';
        break;
      case '/uci-year-location.html':
        title = 'Used Car Inventory Year Location';
        break;
      case '/uci-type-sitemap.html':
        title = 'Used Vehicle Types For Sale';
        break;
      case '/uci-type.html':
        title = 'Used Car Inventory Type';
        break;
      case '/uci-price-under-sitemap.html':
        title = 'Used Vehicles Under Price';
        break;
      case '/uci-sitemaps.html':
        return 'Used Vehicles Sitemap Index';
      case '/about/sitemap-category.html':
        title = 'Categorized';
        break;
      case '/about/sitemap.html':
        title = 'Alphabetical';
        break;
      default:
        title = generateTitleFromPathname(pathname);
    }
  }

  return withSitemapLabel ? `${title} Sitemap` : title;
};

const getCategoriesBreadcrumbs = pathname => {
  const locations = getLocationsFromPathname(pathname);

  return locations.reduce((breadcrumbs, location) => {
    const lastBreadcrumbHref = get(last(breadcrumbs), 'href', '/');
    return [
      ...breadcrumbs,
      {
        href: `${lastBreadcrumbHref}${location}/`,
        title: getLocationName(location),
      },
    ];
  }, []);
};

const getVehicleBreadcrumbs = ({ makeSlug, modelSlug, makeName, modelName }) => {
  const breadcrumbs = [];

  if (makeSlug) breadcrumbs.push(getBaseBreadcrumb(makeName, `/${makeSlug}/`));
  if (modelSlug) breadcrumbs.push(getBaseBreadcrumb(`${makeName} ${modelName}`, `/${makeSlug}/${modelSlug}/`));

  return breadcrumbs;
};

export const getBreadcrumbs = ({ pathname, makeSlug, modelSlug, makeName, modelName }) => {
  const sitemapTitle = getSitemapTitle({ pathname, makeName, modelName });
  const categoriesBreadcrumbs = getCategoriesBreadcrumbs(pathname).map(({ title, href }) =>
    getBaseBreadcrumb(title, href)
  );
  const vehicleBreadcrumbs = getVehicleBreadcrumbs({ makeSlug, modelSlug, makeName, modelName });

  return [getHomeBreadcrumb(), ...vehicleBreadcrumbs, ...categoriesBreadcrumbs, getBaseBreadcrumb(sitemapTitle)];
};
